export var getHumanisedNumber = function getHumanisedNumber(number) {
  var _Number;
  return (_Number = Number(number)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString();
};